import {PushContentTemplateTypes} from '@/consts/inbox/pushContentTypes';
import {
    CompleteTaskTemplate,
    EarnBadgeTemplate,
    NewBadgeTemplate,
} from '@/containers/Inbox/NotificationDetails/components/LoyaltyInboxTemplate';

import {NotificationRegularTemplate} from './NotificationRegularInboxTemplate';

const NOTIFICATION_TEMPLATES = {
    [PushContentTemplateTypes.LOYALTY_EARN_BADGE]: EarnBadgeTemplate,
    [PushContentTemplateTypes.LOYALTY_NEW_BADGE]: NewBadgeTemplate,
    [PushContentTemplateTypes.LOYALTY_COMPLETE_TASK]: CompleteTaskTemplate,
};

export const NotificationDetailsMessage = ({templateType, ...props}) => {
    const NotificationTemplate = NOTIFICATION_TEMPLATES[templateType?.toLowerCase()];

    if (NotificationTemplate) {
        return <NotificationTemplate {...props} />;
    }

    // Fallback to regular notification template
    return <NotificationRegularTemplate {...props} />;
};
